var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ocean",
    cx: "35%",
    cy: "30%",
    r: "85%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8fd0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#1e63d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a2a6b"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "url(#ocean)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f9e44",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 74 q22 -20 52 -8 q16 -22 42 -14 q28 12 48 36 q-16 30 -46 28 q-30 10 -62 -8 q-24 -12 -34 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 132 q18 8 38 2 q10 14 30 10 q14 10 34 4 q-12 22 -40 22 q-30 0 -62 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.6c50be108b74902330752044a1212b4f.svg";
export { ForwardRef as ReactComponent };